<template>
  <Dialog
    v-model:visible="mostrarModal"
    :style="{ width: '350px' }"
    header="Paquete Productos Detalle"
    :modal="true"
    class="p-fluid"
    @hide="ocultarDialog"
  >
    <div class="col-12">
      <div class="p-fluid formgrid grid">
        <div class="field col-12 md:col-12">
          <label for="nombre"
            ><strong>NOMBRE DE PAQUETE: </strong>
            <span class="p-invalid">*</span></label
          >
          <InputText
            id="nombre"
            v-model.trim="data_paqueteproducto.nombre"
            required="true"
            autofocus
            @keyup.enter="savePaquete"
          />
          <small class="p-invalid" v-if="errors.nombre">{{
            errors.nombre[0]
          }}</small>
        </div>
        <div class="field col-12 md:col-12" v-if="data_paqueteproducto.id">
          <label for="estado"
            ><strong>ESTADO: </strong><span class="p-invalid">*</span></label
          >
          <Dropdown
            id="estado"
            v-model="data_paqueteproducto.estado"
            :disabled="!data_paqueteproducto.id"
            :options="estados"
            optionLabel="label"
            placeholder="Seleccione un estado..."
          >
            <template #value="slotProps">
              <span
                :class="'product-badge ' + claseEstado[slotProps.value.value]"
              >
                {{ slotProps.value.label }}
              </span>
            </template>
          </Dropdown>
        </div>
      </div>
    </div>
    <template #footer>
      <div class="field">
        <label class="flex md:justify-content-start"
          ><strong>CAMPOS REQUERIDOS: </strong>
          <span class="p-invalid">*</span></label
        >
      </div>
      <Button
        label="CANCELAR"
        icon="pi pi-times"
        class="p-button-secondary p-button-lg"
        @click="ocultarDialog"
        :disabled="!enviado ? false : true"
      />
      <Button
        :label="data_paqueteproducto.id ? 'ACTUALIZAR' : 'GUARDAR'"
        icon="pi pi-save"
        class="p-button-primary p-button-lg"
        @click="savePaquete"
        :disabled="!enviado ? false : true"
        :loading="enviado"
      />
    </template>
  </Dialog>
</template>

<script>
import PaqueteProductoService from "@/service/PaqueteProductoService";
export default {
  emits: ["closeModal", "actualizarListado"],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    paqueteproducto: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  PaqueteProductoService: null,
  data() {
    return {
      mostrarModal: this.show,
      data_paqueteproducto: this.paqueteproducto,
      enviado: false,
      estados: [
        { label: "Inactivo", value: 0 },
        { label: "Activo", value: 1 },
      ],
      errors: {},
      claseEstado: ["status-outofstock", "status-instock"],
    };
  },
  created() {
    this.PaqueteProductoService = new PaqueteProductoService();
  },
  methods: {
    ocultarDialog() {
      this.errors = {};
      this.mostrarModal = false;
      this.$emit("closeModal");
    },
    savePaquete() {
      this.errors = {};
      this.enviado = true;
      //editar paqueteproducto
      if (this.paqueteproducto.id) {
        let paqueteproducto_enviar = {
          ...this.data_paqueteproducto,
          estado: this.data_paqueteproducto.estado.value,
        };
        this.PaqueteProductoService.updatePaqueteProducto(
          paqueteproducto_enviar
        ).then((data) => {
          if (Object.prototype.hasOwnProperty.call(data, "errors")) {
            this.errors = data.errors;
          } else {
            this.errors = {};
            this.$toast.add({
              severity: "success",
              summary: "Exito!",
              detail: data.mensaje,
              life: 3000,
            });
            this.$emit("actualizarListado");
            this.ocultarDialog();
          }
          this.enviado = false;
        });
      } else {
        //CREANDO UN NUEVO PROVEEDOR
        let tmp = this.data_paqueteproducto;
        this.data_paqueteproducto = {
          ...this.data_paqueteproducto,
          estado: this.data_paqueteproducto.estado.value,
        };
        this.PaqueteProductoService.sendPaqueteProductoNew(
          this.data_paqueteproducto
        ).then((data) => {
          if (Object.prototype.hasOwnProperty.call(data, "errors")) {
            this.errors = data.errors;
            this.data_paqueteproducto = tmp;
          } else {
            this.errors = {};
            this.$toast.add({
              severity: "success",
              summary: "Exito!",
              detail: data.mensaje,
              life: 10000,
            });
            this.$emit("actualizarListado");
            this.ocultarDialog();
          }
          this.enviado = false;
        });
      }
    },
  },
  watch: {
    show(val) {
      this.mostrarModal = val;
    },
    paqueteproducto(val) {
      this.data_paqueteproducto = val;
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/demo/badges.scss";
.p-invalid {
  color: red;
}
</style>
